<!-- No @default: an unrecognised block type must render nothing, not throw.
     $any() narrows the seven-type union to the renderer's own type, which @switch cannot do. -->
@switch (block().type) {
    @case ('callout') {
        <copilot-rich-block-callout [block]="$any(block())" (activateAction)="activateAction.emit($event)" />
    }
    @case ('task_list') {
        <copilot-rich-block-task-list [block]="$any(block())" (activateAction)="activateAction.emit($event)" />
    }
    @case ('actions') {
        <copilot-rich-block-actions [block]="$any(block())" (activateAction)="activateAction.emit($event)" />
    }
    @case ('stat_list') {
        <copilot-rich-block-stat-list [block]="$any(block())" />
    }
    @case ('table') {
        <copilot-rich-block-table [block]="$any(block())" />
    }
    @case ('chart') {
        <copilot-rich-block-chart [block]="$any(block())" />
    }
    @case ('select') {
        <copilot-rich-block-select [block]="$any(block())" (activateAction)="activateAction.emit($event)" />
    }
}
